module.exports = __webpack_public_path__ + "img/registration-bg.f3bc8cf7.png";